/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The feedback scenario to open the feedback dialog with.
 */
export enum FeedbackScenario {
    /**
     * The scenario to give a compliment or positive feedback.
     */
    GiveACompliment = "GiveACompliment",

    /**
     * The scenario to give a complaint or negative feedback.
     */
    ReportAProblem = "ReportAProblem"
}